import { ArrowDownTrayIcon } from "@heroicons/react/24/outline/index.js";
import { PrimaryLoadingIndicator } from "./Loading/PrimaryLoadingIndicator.tsx";
import { LoaderSize } from "./Loading/LoaderSize.tsx";

type Props = {
  onClick: () => void;
  loading?: boolean;
};

export function ExportCsvButton({ onClick, loading }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      className="flex items-center gap-1.5 px-3 py-2 rounded-lg border border-gray-300 bg-white text-gray-700 text-sm font-medium hover:bg-gray-50 disabled:cursor-wait shrink-0"
    >
      {loading ? (
        <PrimaryLoadingIndicator size={LoaderSize.Small} />
      ) : (
        <ArrowDownTrayIcon className="w-4 h-4" />
      )}
      Export CSV
    </button>
  );
}
